import { EditorSelection, StateEffect, StateField } from "@codemirror/state";

import { ManuscriptWidget } from "./base.js";

export const collapsePreambleEffect = StateEffect.define();

export const preambleCollapsedState = StateField.define({
    create() {
        return true;
    },
    update(value, transaction) {
        for (const effect of transaction.effects) {
            if (effect.is(collapsePreambleEffect)) {
                return effect.value;
            }
        }
        return value;
    },
});

export class PreambleWidget extends ManuscriptWidget {
    constructor(expanded = false) {
        super();
        this.expanded = expanded;
    }

    eq(other) {
        return other.expanded === this.expanded;
    }

    toDOM(view) {
        const wrapper = document.createElement("div");
        wrapper.className = "ol-cm-preamble-wrapper";
        wrapper.classList.toggle("ol-cm-preamble-expanded", this.expanded);

        const element = document.createElement("div");
        element.className = "ol-cm-preamble-widget";
        element.dataset.directEdit = "false";
        element.setAttribute("aria-hidden", "true");

        const text = document.createElement("span");
        text.className = "ol-cm-preamble-text";
        text.textContent = this.expanded ? "Hide document preamble" : "Show document preamble";

        const icon = document.createElement("span");
        icon.className = "ol-cm-preamble-expand-icon";
        icon.textContent = this.expanded ? "▾" : "▸";

        element.append(text, icon);

        element.addEventListener("mouseup", (event) => {
            if (event.button !== 0) {
                return;
            }
            event.preventDefault();
            if (this.expanded) {
                view.dispatch({
                    effects: collapsePreambleEffect.of(true),
                });
                return;
            }
            view.dispatch({
                effects: collapsePreambleEffect.of(false),
                selection: EditorSelection.cursor(0),
                scrollIntoView: true,
            });
        });

        wrapper.appendChild(element);
        return wrapper;
    }

    ignoreEvent(event) {
        return event.type !== "mouseup";
    }

    get estimatedHeight() {
        return this.expanded ? -1 : 54;
    }
}
